import React, { useEffect, useRef, useState } from 'react';
import { ArrowUpRightIcon, MenuIcon, XIcon } from 'lucide-react';
import { LogoMascot, Wordmark } from './BrandArtwork';
import { navLinks } from '../data/site';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false);
        toggleRef.current?.focus();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);
  return <header className="sticky top-0 z-50 border-b border-ink/10 bg-cream" data-id="element-152" data-mp="14u2a9tzfat30">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between px-5 md:px-8 lg:px-10" data-id="element-153" data-mp="zw0q15q9gnpy">
        <a href="#top" className="-m-2 inline-flex items-center gap-[3px] p-2" aria-label="Black Comet Labs — back to top" data-id="element-154" data-mp="2gdoipdmq8vqv">
          <LogoMascot className="h-6 w-auto shrink-0 md:h-7" knockoutId="header-mascot-knockout" data-id="element-155" data-mp="29isctsq3ihov" />
          <Wordmark className="h-6 w-auto md:h-7" knockoutId="header-wordmark-knockout" data-id="element-156" data-mp="2ehvinfdwgrxw" />
        </a>

        <div className="hidden items-center gap-10 md:flex" data-id="element-157" data-mp="2jj18n5g6e13q">
          <nav aria-label="Primary" data-id="element-158" data-mp="2ogt2w64alzb3">
            <ul className="flex items-center gap-8" data-id="element-159" data-mp="2ofrqnybjj6rs">
              {navLinks.map(link => <li key={link.href} data-id="element-160" data-mp="1qudkn241kxmh">
                  <a href={link.href} className="text-[14px] font-medium text-ink/70 transition-colors duration-150 ease-out hover:text-ink" data-id="element-161" data-mp="1qr7xhsez45te">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <a href="#lab" className="inline-flex min-h-[44px] items-center gap-2 rounded-[2px] bg-ink px-5 text-[14px] font-medium text-cream transition-colors duration-150 ease-out hover:bg-ink/85" data-id="element-162" data-mp="1832wuttm50yt">
            Explore our apps
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-163" data-mp="14zf0j460h1uv" />
          </a>
        </div>

        <button ref={toggleRef} type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="mobile-menu" className="-mr-2 inline-flex h-11 w-11 items-center justify-center rounded-[2px] text-ink md:hidden" data-id="element-164" data-mp="101val6zyb0n3">
          {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-165" data-mp="h3anrr53ehf9" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-166" data-mp="h5dmr0o83kw4" />}
          <span className="sr-only" data-id="element-167" data-mp="w1bg6b6rib4n">{open ? 'Close menu' : 'Open menu'}</span>
        </button>
      </div>

      <div id="mobile-menu" hidden={!open} className="border-t border-ink/10 bg-cream md:hidden" data-id="element-168" data-mp="qzvt6dl0xujm">
        <nav aria-label="Primary mobile" data-id="element-169" data-mp="27e5gd4dj5d8v">
          <ul className="mx-auto max-w-content px-5" data-id="element-170" data-mp="22gvu1xlfthp9">
            {navLinks.map(link => <li key={link.href} className="border-b border-ink/10" data-id="element-171" data-mp="2a04s4uohttz0">
                <a href={link.href} onClick={() => setOpen(false)} className="block py-4 font-display text-xl font-medium text-ink" data-id="element-172" data-mp="29ytr32mfn0bl">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
        <div className="mx-auto max-w-content px-5 py-5" data-id="element-173" data-mp="252v5fmshnwev">
          <a href="#lab" onClick={() => setOpen(false)} className="inline-flex min-h-[48px] w-full items-center justify-center gap-2 rounded-[2px] bg-ink px-5 text-[15px] font-medium text-cream" data-id="element-174" data-mp="2srxl4p3kbf6q">
            Explore our apps
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-175" data-mp="2nze4tkdhq5y8" />
          </a>
        </div>
      </div>
    </header>;
}